module.exports = __webpack_public_path__ + "img/jingzhunguanhuai2.db43f67c.png";